import { BaseModel } from "@blue-chip/core";
import Team from "./Team";
import Location from "./Location";

export default class Office extends BaseModel {
  static get belongsTo() {
    return [Team, Location];
  }
}
